var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgVideoStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 57.129,
    viewBox: "0 0 47 57.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11419",
    "data-name": "Group 11419",
    transform: "translate(-846.5 -8286.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11418",
    "data-name": "Group 11418",
    transform: "translate(850 8289.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42726",
    "data-name": "Path 42726",
    d: "M1484.15,468.592a23.394,23.394,0,0,0-.449-4.3,19.635,19.635,0,0,0-1.736-5.261,13.224,13.224,0,0,0-3.377-4.283,12.238,12.238,0,0,0-5.1-2.472,16.475,16.475,0,0,0-6.663.014l-.011,0a11.711,11.711,0,0,0-4.544,1.923,17.543,17.543,0,0,0-3.477,3.226,18.924,18.924,0,0,0-2.5,3.937,22.868,22.868,0,0,0-1.468,3.956,30.28,30.28,0,0,0-.752,4.254,25.839,25.839,0,0,0-.073,4.6,21.231,21.231,0,0,0,.845,4.591,14.208,14.208,0,0,0,2.077,4.223,13.264,13.264,0,0,0,2.625,2.8,15.3,15.3,0,0,0,3.167,1.943,15.577,15.577,0,0,0,3.493,1.112l.211.038a14.665,14.665,0,0,0,8.444-1.05,12.06,12.06,0,0,0,4.252-3.247,18.256,18.256,0,0,0,1.349-1.824,15.874,15.874,0,0,0,1.116-2.055,22.79,22.79,0,0,0,1.423-3.687,28.656,28.656,0,0,0,1.148-8.442m-10.952,7.1-.025.06a7.579,7.579,0,0,1-1.1,1.908,4.227,4.227,0,0,1-5.758,1.549,4.954,4.954,0,0,1-1.906-1.884,6.079,6.079,0,0,1-.713-1.9,13.255,13.255,0,0,1-.253-2.418,16.417,16.417,0,0,1,.154-2.526,23.131,23.131,0,0,1,.486-2.479,13.792,13.792,0,0,1,1.667-4.1,6.129,6.129,0,0,1,1.234-1.465,3.8,3.8,0,0,1,1.423-.785,5.986,5.986,0,0,1,2.618-.259,3.355,3.355,0,0,1,1.629.706,4.121,4.121,0,0,1,1.1,1.531,10.126,10.126,0,0,1,.713,2.5,17.913,17.913,0,0,1-.029,5.012,16.75,16.75,0,0,1-1.244,4.543",
    transform: "translate(-1453.932 -438.986)",
    fill: "#fff",
    stroke: "#7833ba",
    strokeLinecap: "round",
    strokeWidth: 7,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42727",
    "data-name": "Path 42727",
    d: "M1527.325,265.351a10.19,10.19,0,1,1-10.177-10.714,10.456,10.456,0,0,1,10.177,10.714",
    transform: "translate(-1503.368 -254.637)",
    fill: "#fff",
    stroke: "#7833ba",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42728",
    "data-name": "Path 42728",
    d: "M1764.186,364.023a10.19,10.19,0,1,1-10.176-10.714,10.456,10.456,0,0,1,10.176,10.714",
    transform: "translate(-1724.186 -346.604)",
    fill: "#fff",
    stroke: "#7833ba",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42729",
    "data-name": "Path 42729",
    d: "M1592.064,338.871a5.092,5.092,0,1,1-5.085-5.354,5.225,5.225,0,0,1,5.085,5.354",
    transform: "translate(-1573.214 -328.157)",
    fill: "#7833ba",
    stroke: "#7833ba",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42730",
    "data-name": "Path 42730",
    d: "M1828.932,437.551a5.091,5.091,0,1,1-5.085-5.353,5.224,5.224,0,0,1,5.085,5.353",
    transform: "translate(-1794.024 -420.268)",
    fill: "#7833ba",
    stroke: "#7833ba",
    strokeLinecap: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11417",
    "data-name": "Group 11417",
    transform: "translate(850 8290.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11416",
    "data-name": "Group 11416",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37159",
    "data-name": "Path 37159",
    d: "M1484.15,468.592a23.394,23.394,0,0,0-.449-4.3,19.635,19.635,0,0,0-1.736-5.261,13.224,13.224,0,0,0-3.377-4.283,12.238,12.238,0,0,0-5.1-2.472,16.475,16.475,0,0,0-6.663.014l-.011,0a11.711,11.711,0,0,0-4.544,1.923,17.543,17.543,0,0,0-3.477,3.226,18.924,18.924,0,0,0-2.5,3.937,22.868,22.868,0,0,0-1.468,3.956,30.28,30.28,0,0,0-.752,4.254,25.839,25.839,0,0,0-.073,4.6,21.231,21.231,0,0,0,.845,4.591,14.208,14.208,0,0,0,2.077,4.223,13.264,13.264,0,0,0,2.625,2.8,15.3,15.3,0,0,0,3.167,1.943,15.577,15.577,0,0,0,3.493,1.112l.211.038a14.665,14.665,0,0,0,8.444-1.05,12.06,12.06,0,0,0,4.252-3.247,18.256,18.256,0,0,0,1.349-1.824,15.874,15.874,0,0,0,1.116-2.055,22.79,22.79,0,0,0,1.423-3.687,28.656,28.656,0,0,0,1.148-8.442m-10.952,7.1-.025.06a7.579,7.579,0,0,1-1.1,1.908,4.227,4.227,0,0,1-5.758,1.549,4.954,4.954,0,0,1-1.906-1.884,6.079,6.079,0,0,1-.713-1.9,13.255,13.255,0,0,1-.253-2.418,16.417,16.417,0,0,1,.154-2.526,23.131,23.131,0,0,1,.486-2.479,13.792,13.792,0,0,1,1.667-4.1,6.129,6.129,0,0,1,1.234-1.465,3.8,3.8,0,0,1,1.423-.785,5.986,5.986,0,0,1,2.618-.259,3.355,3.355,0,0,1,1.629.706,4.121,4.121,0,0,1,1.1,1.531,10.126,10.126,0,0,1,.713,2.5,17.913,17.913,0,0,1-.029,5.012,16.75,16.75,0,0,1-1.244,4.543",
    transform: "translate(-1453.932 -438.986)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37156",
    "data-name": "Path 37156",
    d: "M1527.325,265.351a10.19,10.19,0,1,1-10.177-10.714,10.456,10.456,0,0,1,10.177,10.714",
    transform: "translate(-1503.368 -254.637)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37157",
    "data-name": "Path 37157",
    d: "M1764.186,364.023a10.19,10.19,0,1,1-10.176-10.714,10.456,10.456,0,0,1,10.176,10.714",
    transform: "translate(-1724.186 -346.604)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37155",
    "data-name": "Path 37155",
    d: "M1592.064,338.871a5.092,5.092,0,1,1-5.085-5.354,5.225,5.225,0,0,1,5.085,5.354",
    transform: "translate(-1573.214 -328.157)",
    fill: "#7833ba",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37158",
    "data-name": "Path 37158",
    d: "M1828.932,437.551a5.091,5.091,0,1,1-5.085-5.353,5.224,5.224,0,0,1,5.085,5.353",
    transform: "translate(-1794.024 -420.268)",
    fill: "#7833ba",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgVideoStep1);
export default __webpack_public_path__ + "static/media/img_video_step_1.1e0765fdca610ae11228a3a99582b3b7.svg";
export { ForwardRef as ReactComponent };